import { TYPE_INPUT } from "@lhd/components/TableForm/types";
import AddressEditCell from "./AddressEditCell";
import DateEditCell from "./DateEditCell";
import DateMonthEditCell from "./DateMonthEditCell";
import EmailEditCell from "./EmailEditCell";
import NumberPhoneEditCell from "./NumberPhoneEditCell";
import PositiveNumberEditCell from "./PositiveNumberEditCell";
import PrefectureEditCell from "./PrefectureEditCell";
import RegisterCodeEditCell from "./RegisterCodeEditCell";
import SelectEditCell from "./SelectEditCell";
import TextAreaEditCell from "./TextAreaEditCell";
import TextEditCell from "./TextEditCell";
import ExtendedTimeEditCell from "./ExtendedTimeEditCell";
import WorkerTypeOptionsEditCell from "./WorkerTypeOptionsEditCell";
import WorkingTypeEditCell from "./WorkingTypeEditCell";
import ZipcodeEditCell from "./ZipcodeEditCell";

export const MAP_COMPONENT = {
  [TYPE_INPUT.ADDRESS]: AddressEditCell,
  [TYPE_INPUT.DATE]: DateEditCell,
  [TYPE_INPUT.DATE_MONTH]: DateMonthEditCell,
  [TYPE_INPUT.EMAIL]: EmailEditCell,
  [TYPE_INPUT.INPUT_POSITIVE_NUMBER]: PositiveNumberEditCell,
  [TYPE_INPUT.PHONE_NUMBER]: NumberPhoneEditCell,
  [TYPE_INPUT.PREFECTURE]: PrefectureEditCell,
  [TYPE_INPUT.REGISTER_CODE]: RegisterCodeEditCell,
  [TYPE_INPUT.SELECT]: SelectEditCell,
  [TYPE_INPUT.TEXT_AREA]: TextAreaEditCell,
  [TYPE_INPUT.TEXT]: TextEditCell,
  [TYPE_INPUT.EXTENDED_TIME]: ExtendedTimeEditCell,
  [TYPE_INPUT.WORKER_TYPE_OPTIONS]: WorkerTypeOptionsEditCell,
  [TYPE_INPUT.WORKING_TYPE]: WorkingTypeEditCell,
  [TYPE_INPUT.ZIPCODE]: ZipcodeEditCell,
};
